// 164 = size of the header + spacings
const HEADER_HEIGHT = 164

export const scrollToElement = (offset) => {
  return window.scrollTo({
    behavior: 'smooth',
    top: offset - HEADER_HEIGHT,
  })
}
